<template>
  <div class="order-page">
    <div class="container">
      <div :class="{up:!showSearch}" class="opera-btn-group">
        <div class="opera-icon">
          <span class="pull-right" style="margin-left: 10px">
            <perm label="mdm-batchNumber-add">
              <span @click.stop="add">
                   <a href="#" class="btn-circle" @click.prevent="" style="margin-right: 5px"><i
                     class="el-icon-t-plus"></i> </a>添加
              </span>
            </perm>
          </span>
        </div>
        <el-form class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="8">
              <oms-form-row :span="4" label="货品">
                <el-select :clearable="true" :remote-method="queryManageGoods" @change="goodsChange" @click.native.once="queryManageGoods('')"
                           filterable placeholder="请输入名称搜索货品"
                           popperClass="custom-select" remote v-model="searchWord.goodsId">
                  <el-option :key="item.id" :label="item.name" :value="item.goodsId" v-for="item in manageGoods">
                    <manage-goods-option :optionItem="item"/>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="5" label="批号">
                <el-input placeholder="请输入批号" v-model="searchWord.batchNumber"></el-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="4" label="">
                <el-button @click="searchInOrder" native-type="submit" plain type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list-status container" style="margin-bottom:20px">
        <div class="status-item" :class="{'active':key==activeStatus,'item-right':item.type===0} "
             v-for="(item,key) in orgType" style="width: 100px"
             @click="changeType(key,item)">
          <div class="status-bg" :class="['b_color_'+key]"></div>
          <div><i class="el-icon-caret-right" v-if="key==activeStatus"></i>{{item.title}}<span
            class="status-num">{{item.num}}</span></div>
        </div>
      </div>
      <div class="order-list clearfix">
        <el-row class="order-list-header">
          <el-col :span="2">货品编号</el-col>
          <el-col :span="5">货品名称</el-col>
          <el-col :span="3">批号</el-col>
          <el-col :span="4">生产厂商</el-col>
          <el-col :span="2">生产日期</el-col>
          <el-col :span="3">有效期至</el-col>
          <el-col :span="2">状态</el-col>
          <el-col :span="3">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-if="!loadingData&&!batches.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentItemId===item.id, 'is-error': item.batchStatus === '2'}]" @click.prevent="showDetail(item)"
               class="order-list-item order-list-item-bg"
               v-for="item in batches">
            <el-row>
              <el-col :span="2" class="pt R">
                <span>{{ item.goodsCode }}</span>
              </el-col>
              <el-col :span="5" class="pt">
                <span>{{ item.goodsName }}</span>
                <div>规格: {{ item.specification }}</div>
              </el-col>
              <el-col :span="3" class="pt">
                {{ item.batchNumber }}
              </el-col>
              <el-col :span="4" class="pt">
                <span>{{ item.orgName }}</span>
              </el-col>
              <el-col :span="2" class="pt">
                <span>{{ item.productionDate | date }}</span>
              </el-col>
              <el-col :span="3" class="pt">
                <span>{{ item.expirationDate | date }}</span>
              </el-col>
              <el-col :span="2" class="pt">
                  {{formatBatchStatus(item.batchStatus)}}
              </el-col>
              <el-col :span="3" class="opera-btn">
                <des-btn @click="editBatchNumber(item)" icon="edit" perm="mdm-batchNumber-update"
                         v-show="['0','2'].includes(item.batchStatus)">编辑
                </des-btn>
              </el-col>
            </el-row>
          </div>
        </div>

      </div>

      <div class="text-center" v-show=" batches.length&& !loadingData">
        <el-pagination :current-page="pager.currentPage" :page-size="20"
                       :page-sizes="[20,50,100]"
                       :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>

    <page-right :css="{'width':'1000px','padding':0}" :show="showDetailPart" @right-close="resetRightBox">
      <detail :currentItem="currentItem" :id="currentItemId" :showInfoPart="showDetailPart" :formatBatchStatus="formatBatchStatus"
              @change="getBatcheNumbers(pager.currentPage)" @right-close="resetRightBox"></detail>
    </page-right>

    <page-right :css="{'width':'1000px','padding':0}" :show="showInfoPart" @right-close="closeTitle">
      <edit-form :actionType="actionType" :currentItem="form" :id="currentItemId" @change="getBatcheNumbers(pager.currentPage)"
                 @close="resetRightBox"></edit-form>
    </page-right>
  </div>
</template>
<script>
  import detail from './detail.vue';
  import editForm from './form/editForm.vue';
  import methodsMixin from '@/mixins/methodsMixin';

  export default {
    components: {
      detail, editForm
    },
    mixins: [methodsMixin],
    data() {
      return {
        showSearch: true,
        showDetailPart: false,
        showInfoPart: false,
        loadingData: true,
        batches: [],
        filters: {
          orgId: '',
          keyWord: '',
          goodsId: '',
          batchStatus: '1',
          fileFlag: true
        },
        searchWord: {
          orgId: '',
          keyWord: '',
          goodsId: '',
          batchNumber: '',
          batchStatus: '1',
          fileFlag: false
        },
        factories: [], // 厂商列表
        orgList: [], // 货主列表,
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        },
        form: {},
        currentItemId: '',
        currentItem: {},
        orgType: {
          0: {'title': '审核通过', 'num': '', 'batchStatus': '1'},
          1: {'title': '未审核', 'num': '', 'batchStatus': '0'},
          2: {'title': '审核不通过', 'num': '', 'batchStatus': '2'}
        },
        activeStatus: 0,
        actionType: ''
      };
    },
    beforeRouteLeave (to, from, next) {
      if(!this.showInfoPart) {
        next(true);
        return;
      }
      this.$confirm('信息未保存，是否关闭', '', {
        confirmButtonText: ' 是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        next(true);
      }).catch(() => {
        next(false);
      })
    },
    mounted() {
      this.getBatcheNumbers(1);
    },
    methods: {
      formatBatchStatus(val) {
        let item = Object.values(this.orgType).find(f => f.batchStatus === val);
        return item && item.title || val;
      },
      closeTitle() {
        this.$confirm('信息未保存，是否关闭', '', {
          confirmButtonText: ' 是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.resetRightBox();
        })
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getBatcheNumbers(1);
      },
      handleCurrentChange(val) {
        this.getBatcheNumbers(val);
      },
      setFileFlag: function () {
        this.searchWord.fileFlag = !this.searchWord.fileFlag;
      },
      changeType: function (key, item) {// 根据当前选中的标签，重置状态等相关参数。
        this.activeStatus = key;
        this.filters.batchStatus = item.batchStatus;
        this.searchWord.batchStatus = item.batchStatus;
        this.getBatcheNumbers(1);
      },
      deleteBatchNumber: function (item) {
        this.$confirm('警告：该操作会影响到该批号关联的数据，请慎重操作，确认要删除批号"' + item.batchNumber + '"?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$http.delete('/dhs-batch-number/' + item.id, {}).then(() => {
            this.getBatcheNumbers(1);
            this.$notify.success({
              title: '成功',
              message: '已成功删除批号"' + item.batchNumber + '"的信息'
            });
          });
        });
      },
      editBatchNumber: function (item) {
        this.actionType = 'edit';
        this.form = Object.assign({}, item);
        this.showInfoPart = true;
      },
      add: function () {
        this.actionType = 'add';
        this.showInfoPart = true;
        this.form = {
          'batchNumber': '',
          'batchReleaseCount': '',
          'batchReleaseDate': '',
          'batchReleaseNumber': '',
          'customsFormNumber': '',
          'portInspectionNumber': '',
          'createTime': '',
          'createdBy': '',
          'expirationDate': '',
          'goodsId': '',
          'goodsName': '',
          'id': '',
          'orgId': '',
          'orgName': '',
          'productionDate': '',
          'specification': ''
        };
      },
      getBatcheNumbers(pageNo) { // 得到批次列表
        this.batches = [];
        this.pager.currentPage = pageNo;
        this.loadingData = true;
        let params = Object.assign({
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        this.$http.get('/code-batchNumber', {params}).then(res => {
          this.batches = res.data.list;
          this.loadingData = false;
          this.pager.count = res.data.count;
        });
        this.queryStatusNum(params);
      },
      queryStatusNum: function (paramsBody) {
        let params = Object.assign({}, paramsBody);
        this.$http.get('/code-batchNumber/count', {params}).then(res => {
          let data = res.data;
          this.orgType[0].num = data['confirm'] || 0;
          this.orgType[1].num = data['notConfirm'] || 0;
          this.orgType[2].num = data['rejectAudit'] || 0;
        });
      },
      showDetail(item) {
        this.currentItemId = item.id;
        this.currentItem = item;
        this.$nextTick(() => {
          this.showDetailPart = true;
        });
      },
      resetRightBox() {
        this.showDetailPart = false;
        this.showInfoPart = false;
        this.actionType = '';
      },
      searchInOrder: function () {// 搜索
        Object.assign(this.filters, this.searchWord);
        this.goodsBatchNumberList = [];
        this.getBatcheNumbers(1);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          orgId: '',
          keyWord: '',
          goodsId: '',
          batchNumber: '',
          batchStatus: '',
          fileFlag: false
        };
        Object.assign(this.searchWord, temp);
        Object.assign(this.filters, temp);
        this.getBatcheNumbers(1);
      },
      goodsChange(val) {
        this.searchWord.batchNumber = '';
        this.queryGoodsNumber('searchWord.goodsId')('');
      }
    }
  };
</script>
